import { InfoWindow, OverlayView } from "@react-google-maps/api";
import { PersonStanding, X } from "lucide-react";
import { Dispatch, FC, SetStateAction, useEffect, useState } from "react";
import OrderCard from "./OrderCard";
import { Orders   } from "@/interface/entityInterface";
import { Button } from "@/components/ui/button";
import { useUserContext } from "@/context/UserContext";
import { getSettings } from "@/api/settings";

interface Props {
  order: Orders;
  orderId: number;
  setOrderId: Dispatch<SetStateAction<number>>;
  setVehicleId: Dispatch<SetStateAction<number>>;
}

const OrderMarker: FC<Props> = ({order, orderId, setOrderId, setVehicleId}) => {
  const {decodedToken} = useUserContext()
  const [assignByDriver, setAssignByDriver] = useState(false)

  useEffect(() => {
    if (!decodedToken) return;
    const getAssignByDriver = async () => {
      const {show_driver_on_order_assign} = await getSettings(decodedToken.settings.id)
      setAssignByDriver(show_driver_on_order_assign)
    }

    getAssignByDriver()
  }, [decodedToken])

  return (
    <div className="relative">
      {order.id === orderId && (
        <InfoWindow
          position={{
            lat: order.pickup_latitude,
            lng: order.pickup_longitude
          }}
          options={{
            pixelOffset: new google.maps.Size(0, -20),
            headerDisabled: true,
            maxWidth: 400,
          }}
        >
          <div className="relative">
            <OrderCard item={order} assignByDriver={assignByDriver} setVehicleId={setVehicleId} />
            <div className="absolute top-2 right-2">
              <Button variant="ghost" onClick={() => setOrderId(0)}>
                <X />
              </Button>
            </div>
          </div>
        </InfoWindow>
      )}
      <OverlayView
        position={{ lat: order.pickup_latitude, lng: order.pickup_longitude }}
        mapPaneName={OverlayView.OVERLAY_MOUSE_TARGET} // can be OVERLAY_LAYER for static ones
      >
        <div
          className="relative flex flex-col items-center hover:cursor-pointer"
          style={{ transform: "translate(-50%, -100%)" }}
          onClick={() => setOrderId(order.id)}
        >
          {/* User Icon */}
          <div className="bg-yellow-500 dark:bg-gray-800 rounded-full shadow-lg p-2 border border-gray-200 dark:border-gray-700">
            <PersonStanding className="w-6 h-6" />
          </div>

          {/* Optional small pointer triangle */}
          <div
            className="w-0 h-0 border-l-4 border-r-4 border-t-8 border-transparent border-t-gray-300 dark:border-t-gray-700"
            style={{ marginTop: "-2px" }}
          />
        </div>
      </OverlayView>
    </div>
  );
};

export default OrderMarker;
